import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FontPreloaderService {
  preloadFonts() {
    const fonts = [
      {
        family: 'Open Sans',
        src: "url('fonts/OpenSans-Semibold.woff2') format('woff2')",
        options: {
          weight: '600',
          style: 'normal'
        }
      },
      {
        family: 'safdings',
        src: "url('fonts/safdings.woff') format('woff')",
        options: {
          weight: 'normal',
          style: 'normal'
        }
      },
      {
        family: 'Open Sans',
        src: "url('fonts/OpenSans-Bold.woff2') format('woff2')",
        options: {
          weight: 'Bold',
          style: 'normal'
        }
      }
    ];

    for (const { family, src, options } of fonts) {
      const font = new FontFace(family, src, options);
      font
        .load()
        .then(() => (document.fonts as any).add(font))
        // eslint-disable-next-line no-console -- can't see any reason to have an error while loading bundled fonts but keeping a simpe console.error here for now
        .catch(err => console.error(err));
    }
  }
}
